import React from 'react';
import '../styles/tavern-components.css';

export type BadgeType = 'type' | 'open' | 'private';

export interface TavernBadgeProps {
  type: BadgeType;
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

/**
 * Badge component for event types and visibility
 * 
 * @example
 * // Event type badge
 * <TavernBadge type="type" icon="🎲">
 *   Board Game
 * </TavernBadge>
 * 
 * @example
 * // Visibility badge
 * <TavernBadge type="open" icon="🌐">
 *   Open
 * </TavernBadge>
 * 
 * @example
 * // Private event badge
 * <TavernBadge type="private" icon="🔒">
 *   Private
 * </TavernBadge>
 */
export function TavernBadge({
  type,
  children,
  icon,
  className = '',
}: TavernBadgeProps) {
  const typeClass = `tavern-badge--${type}`;

  return (
    <span className={`tavern-badge ${typeClass} ${className}`.trim()}>
      {icon && <span className="tavern-badge-icon">{icon}</span>}
      {children}
    </span>
  );
}

// Specific badge components for convenience
export function EventTypeBadge({
  icon,
  children,
}: {
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <TavernBadge type="type" icon={icon}>
      {children}
    </TavernBadge>
  );
}

export function OpenBadge() {
  return (
    <TavernBadge type="open" icon="🌐">
      Open
    </TavernBadge>
  );
}

export function PrivateBadge() {
  return (
    <TavernBadge type="private" icon="🔒">
      Private
    </TavernBadge>
  );
}
